import type { Editor } from '@tiptap/core';
import { Braces } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface PlaceholderBarProps {
  editor: Editor | null;
  placeholders: string[];
  disabled?: boolean;
  className?: string;
}

/**
 * Панель быстрой вставки Handlebars-плейсхолдеров.
 * Вставляет переменную как обычный текст в позицию курсора —
 * на бэкенде она будет подставлена Handlebars-движком.
 */
export function PlaceholderBar({
  editor,
  placeholders,
  disabled,
  className,
}: PlaceholderBarProps) {
  if (placeholders.length === 0) {
    return null;
  }

  const isDisabled = disabled || !editor || !editor.isEditable;

  const insert = (token: string) => {
    if (!editor) {
      return;
    }
    editor.chain().focus().insertContent(token).run();
  };

  return (
    <div
      className={cn(
        'flex flex-wrap items-center gap-1.5 border-b bg-background px-3 py-2',
        className,
      )}
    >
      <span className="mr-1 flex items-center gap-1 text-xs font-medium text-muted-foreground">
        <Braces className="size-3.5" />
        Переменные
      </span>
      {placeholders.map((token) => (
        <Button
          key={token}
          type="button"
          variant="outline"
          size="sm"
          className="h-7 font-mono text-xs"
          disabled={isDisabled}
          onClick={() => insert(token)}
        >
          {token}
        </Button>
      ))}
    </div>
  );
}
